module.exports = __webpack_public_path__ + "img/log_on_card.cd9a5776.png";